module.exports = __webpack_public_path__ + "static/ptp-de383d3112ad7b2e20b6828bc80c6eb8.png";